<psc-dialog
  [maxWidthPercentage]="50"
  *ngIf="showInfoDialog"
  [title]="'info_text_title' | transloco"
  (closeClicked)="showInfoDialog = false">
  <div class="whitespace-pre-wrap" [innerHTML]="infoText"></div>
</psc-dialog>
